export function getExcerptLengthInitialState() {
    return {
        length: undefined,
    };
}
